/**
 * Genesys specific Roles enums
 */
export enum Role {
  ADMINISTRATOR = 'Administrator',
  ANALYST = 'Analyst',
  AGENT = 'Agent',
  BUSINESS_USER = 'Business User',
  DEVELOPER = 'Developer',
  IT = 'IT',
  MANAGER_OR_SUPERVISOR = 'Manager or Supervisor',
  MANAGER = 'Manager',
  SUPERVISOR = 'Supervisor',
  LEARNING_PATHS_BY_ROLE = 'Learning Paths by Role',
}
